import { clients } from '@/services/client.factory'
import authstore from '@/store/modules/auth';

const issues = {
    namespaced: true,
    state: {
        item: null,
        items: [],
        issueCategories : [],
        error: null,
        errors: {},
    },
    getters: {
        item: (state) => state.item,
        items: (state) => state.items,
        issueCategories: (state) => state.issueCategories,
        error: (state) => state.error,
        errors: (state) => state.errors,
    },
    mutations: {
        ISSUE_SET_ITEM(state, item) {
            Object.assign(state, { item })
        },
        ISSUE_CREATE_ITEM(state, item) {
            state.items.push(item);
        },
        ISSUE_UPDATE_ITEM(state, item) {
            Object.assign(state.items[item.editedIndex], item);
            //state.item = Object.assign({}, state.item, item)
        },
        ISSUE_SET_ITEMS(state, items) {
            Object.assign(state, { items })
        },
        ISSUE_CATEGORIES_SET_ITEMS(state, issueCategories) {
            Object.assign(state, { issueCategories })
        },
        ISSUE_SET_ERROR(state, error) {
            Object.assign(state, { error })
        },
        ISSUE_SET_ERRORS(state, errors) {
            Object.assign(state, { errors })
        },
        ISSUE_CATEGORY_REMOVE_ITEM(state, item) {
            console.log("removeeeee", state.issueCategories)
            console.log("itemmmmm", item)
            const index = state.issueCategories.findIndex(i => i.id === item.id);
            console.log("indexxx", index)
            state.issueCategories.splice(index, 1);
        }
    },
    actions: {
        async getIssueCategories({ commit }) {
            let jwt = authstore.getters.jwtDecoded(authstore.state);
            await clients.placeServiceClient.getIssueCategories()
                .then((res) => res.data)
                .then((data) =>
                    commit('ISSUE_CATEGORIES_SET_ITEMS', data)
                )
        },
        async getItems({ commit }, { page, itemsPerPage, sortField, sortOrder, filter }) {
            console.log("get place store filter", filter)
            // filter["cityCode"] = authstore.getters.jwtDecoded(authstore.state).city_code;
            filter.cityCode = authstore.getters.jwtDecoded(authstore.state).city_code;
            let body = {
                pageNumber: page,
                pagesize: itemsPerPage,
                sortField: sortField,
                sortOrder: sortOrder,
                searchCriteria: filter
            }
            console.log("store getitems before")

            // await clients.placeServiceClient.searchIncidents(body)
            await clients.placeServiceClient.searchIssues(body)
                .then((res) => res.data)
                .then((data) => {
                    console.log(data);
                    commit('ISSUE_SET_ITEMS', data);
                })
            console.log("store getitems after")
        },
        async replyIssue({ commit }, item) {
            let jwt = authstore.getters.jwtDecoded(authstore.state);
            let body = {
                issueId: item.issueId,
                operatorReply: item.operatorReply,
                status: item.status
            }

            console.log("store addddd before")
            await clients.placeServiceClient.operatorProcessOnIssue(body);
            console.log("store addddd after")
            //commit('PLACE_CREATE_ITEM', body);
        },
        async addIssueCategory({ commit }, issue) {
            console.log("News issue category is called.",issue)
            console.log(issue)
            console.log(issue.issueCategoryName)
            let jwt = authstore.getters.jwtDecoded(authstore.state);
            await clients.placeServiceClient.addIssueCategory(issue.issueCategoryName);
            console.log("After News Create Request")
            //commit('PLACE_CREATE_ITEM', body);
        },
        async deleteIssueCategory({ commit }, item) {
            await clients.placeServiceClient.deleteIssueCategory(item.issue.id);
            commit('ISSUE_CATEGORY_REMOVE_ITEM', item.issue);
        },
    }
}

export default issues;